import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addAttrezzature, apiRequestFailure, apiRequestStart, apiRequestSuccess, deleteattrezzature, setAttrezzature, setSingleattrezzature } from "./attrezzaturaSlice";
import attrezzatureApi from "../../services/attrezzatureApi";


// Fetch all sensori
export const fetchAttrezzature = createAsyncThunk(
    "attrezzature/fetchAttrezzature",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await attrezzatureApi.getAllattrezzature();
            dispatch(setAttrezzature(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const createAttrezzature = createAsyncThunk(
    "attrezzature/createAttrezzature",
    async (payload, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await attrezzatureApi.createAttrezzature(payload);
            // toast.success(response?.data?.message)
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

export const getAttrezzatura = createAsyncThunk(
    "attrezzatura/getAttrezzatura",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await attrezzatureApi.getOptionAttrezzatura();

            dispatch(addAttrezzature(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create Trattamenti.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const deleteAttrezzatureByID = createAsyncThunk(
    "attrezzature/deleteAttrezzatureByID",
    async (id, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            let res = await attrezzatureApi.deleteAttrezzature(id);
            dispatch(deleteattrezzature(id))
            toast.success(res?.data?.message)
            dispatch(apiRequestSuccess());
            return id;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to delete sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

export const fetchSingleAttrezzatture = createAsyncThunk(
    "attrezzatture/fetchSingleAttrezzatture",
    async (id, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await attrezzatureApi.getAttrezzature(id);
            dispatch(setSingleattrezzature(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch sensore.";  // Handle error
            dispatch(apiRequestFailure(errorMessage));  // Dispatch API request failure
            throw new Error(errorMessage);  // Throw error for further handling
        }
    }
);

export const updateAttrezzature = createAsyncThunk(
    "attrezzature/updateAttrezzature",
    async ({ id, data }, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await attrezzatureApi.updateAttrezzature(id, data);
            // toast.success(response?.data?.message)
            dispatch(apiRequestSuccess());
            dispatch(fetchAttrezzature())
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to update sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);

// export const fetchSiccurezza = createAsyncThunk(
//     "trattamenti/fetchSiccurezza",
//     async (_, { dispatch }) => {
//         dispatch(apiRequestStart());
//         try {
//             const response = await trattamentiApi.getSiccurezza();
//             dispatch(addSiccurezza(response.data.data));
//             dispatch(apiRequestSuccess());
//             return response.data;
//         } catch (error) {
//             const errorMessage =
//                 error.response?.data?.message || "Failed to create Trattamenti.";
//             dispatch(apiRequestFailure(errorMessage));
//             throw new Error(errorMessage);
//         }
//     }
// );
// export const fetchTrattamento = createAsyncThunk(
//     "trattamenti/fetchTrattamento",
//     async (_, { dispatch }) => {
//         dispatch(apiRequestStart());
//         try {
//             const response = await trattamentiApi.getTrattamento();
//             dispatch(addTrattamento(response.data.data));
//             dispatch(apiRequestSuccess());
//             return response.data;
//         } catch (error) {
//             const errorMessage =
//                 error.response?.data?.message || "Failed to create Trattamenti.";
//             dispatch(apiRequestFailure(errorMessage));
//             throw new Error(errorMessage);
//         }
//     }
// );

// export const createTrattamenti = createAsyncThunk(
//     "trattamenti/createTrattamenti",
//     async (payload, { dispatch }) => {
//         dispatch(apiRequestStart());
//         try {
//             const response = await trattamentiApi.createTrattamenti(payload);
//             toast.success(response?.data?.message)
//             dispatch(apiRequestSuccess());
//             return response.data;
//         } catch (error) {
//             const errorMessage =
//                 error.response?.data?.message || "Failed to create sensore.";
//             dispatch(apiRequestFailure(errorMessage));
//             throw new Error(errorMessage);
//         }
//     }
// );


// export const fetchSingleTrattamenti = createAsyncThunk(
//     "trattamenti/fetchSingleTrattamenti",
//     async (id, { dispatch }) => {
//         dispatch(apiRequestStart());
//         try {
//             const response = await trattamentiApi.getTrattamenti(id);
//             dispatch(setSingleTrattamenti(response.data.data));
//             dispatch(apiRequestSuccess());
//             return response.data;
//         } catch (error) {
//             const errorMessage =
//                 error.response?.data?.message || "Failed to fetch sensore.";  // Handle error
//             dispatch(apiRequestFailure(errorMessage));  // Dispatch API request failure
//             throw new Error(errorMessage);  // Throw error for further handling
//         }
//     }
// );



